import { Component, OnInit, Inject, NgModule, Renderer2 } from '@angular/core';

import { NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { TemplateRef } from '@angular/core';
import { RouterModule } from '@angular/router';
import { ViewChild } from '@angular/core';
import { Router } from '@angular/router';
import { MatTableDataSource } from '@angular/material/table';;
import { SelectionModel } from '@angular/cdk/collections';
import { CurrencyService } from '../currency.service';
import { NotificationsService, NotificationType, SimpleNotificationsModule } from 'angular2-notifications';
import { HttpClientModule } from '@angular/common/http';
import { CommonModule } from '@angular/common';

import { MatFormFieldModule } from '@angular/material/form-field';
import { MatInputModule } from '@angular/material/input';
import { FormsModule } from '@angular/forms';
import { NgZone } from '@angular/core';
import { ActivatedRoute, ParamMap } from '@angular/router';
import { MasterService } from '../../../../../master.service';
import {  Options } from 'angular2-notifications';
import { DeleteConfirmationModalComponent } from '../delete-confirmation-modal/delete-confirmation-modal.component';
import { BusyButtonDirective } from '../../../../../core/directives/busy-button.directive';


@Component({
  selector: 'app-currency',
  standalone: true,
  imports: [BusyButtonDirective, RouterModule, HttpClientModule, CommonModule,SimpleNotificationsModule, CommonModule,
    FormsModule, // For ngModel support
    MatFormFieldModule,
    MatInputModule],
  templateUrl: './currency.component.html',
  styleUrl: './currency.component.scss'
})
export class CurrencyComponent implements OnInit {
  pageEvent: any;
  element: any = {};

    // Define notification options with the correct type
    notificationOptions: Options = {
      timeOut: 1000,             // Notification duration in ms
      showProgressBar: true,     // Show progress bar
      pauseOnHover: true,        // Pause timeout on hover
      clickToClose: true,
      position: ['top', 'right'],     // Close notification on click
    };

  currencyList: any = [];
  selection = new SelectionModel<any>(false, []);
  dataSource = new MatTableDataSource<any>();

  length = 100;
  pageSizeOptions = [5, 10, 25, 100];
  pageSize = 10;
  currentPage = 0;
  totalElements = 0;
  totalPages = 0;
  Math = Math;
  constructor(private notifications: NotificationsService,public masterService: MasterService, public currencyService: CurrencyService, private ngZone: NgZone, private route: ActivatedRoute, private router: Router, private modalService: NgbModal) {
  }

  ngOnInit() {
    this.element.searchKey = null;
    this.element.page = this.currentPage;
    this.element.size = this.pageSize;
    this.element.sortField = "currencyName";
    this.element.sortOrder = "asc";
    this.getList();
  }
  getList() {
    console.log("List called ", this.element);
    console.log("Service Obejct ", this.currencyService);
    this.currencyService.getCurrency(this.element).subscribe(data => {
      console.log("received data ", data);
      this.currencyList = data.content;
      this.totalElements = data.totalElements;
      this.totalPages = data.totalPages;
      this.length = this.totalElements;
      this.dataSource.data = this.currencyList;
      console.log("this.currencyList ", this.currencyList);
    });
  }

  editCurrency(index: any) {
    console.log("editCurrency called ");

    this.masterService.checkFeature('MASTER.CURRENCY.MODIFY', '/masters/editcurrency/' + this.currencyList[index].id);

  }

  addCurrency() {
    console.log("addCurrency called ");
    this.masterService.checkFeature('MASTER.CURRENCY.CREATE', '/masters/addcurrency');

  }


  deleteCurrency(index: any) {
    console.log("Select currency index  ", index);
    let currency = this.currencyList[index];
    console.log("Select currency ", currency);
    
    if(this.masterService.checkFeatureFound('MASTER.CURRENCY.DELETE')==false){
      console.log("No permission to delete!!");
      return;
    }

    // Show confirmation dialog
    const modalRef = this.modalService.open(DeleteConfirmationModalComponent, {
      centered: true,
      backdrop: 'static',
      keyboard: false
    });
    
    modalRef.componentInstance.currencyName = currency.currencyName;
    modalRef.componentInstance.currencyCode = currency.currencyCode;
    
    modalRef.result.then((result) => {
      if (result === 'yes') {
        // User confirmed deletion
        this.performDelete(currency.id);
      }
    }, (reason) => {
      // Modal was dismissed
      console.log('Delete operation cancelled');
    });
  }

  private performDelete(id: number) {
    this.currencyService.delete(id).subscribe(data => {
      console.log("Received delete data ", data);
      if (data.status != true) {
        console.log("Error While deleting currency ", data.responseDescription);
        this.notifications.error('Error', 'Currency delete failed!');
        return;
      } else {
        console.log("delete success ", data);
        this.notifications.success('Success', 'Currency deleted successfully!');
        this.getList();
      }
    },
    error => {
      console.log("currency Deleted Not successfully.", error);
      this.notifications.error('Error', 'Currency delete failed!');
    });
  }


  searchKey() {
    console.log("searchKey called ");
    if (this.element == null || this.element == undefined)
      return;
    this.currencyService.searchKey(this.element).subscribe({
      next: (data) => {
        this.ngZone.run(() => {
          this.currencyList = data?.content.content || [];
        });
      },
      error: (err) => {
        console.error('Search error:', err);
      },
    });
  }

  clearSearch() {
    console.log("clearSearch called");
    if (this.element.searchKey != null) {
      this.element.searchKey = null;
      this.getList();
    }
  }

  onPageChange(event: any) {
    this.currentPage = event.pageIndex;
    this.pageSize = event.pageSize;
    this.element.page = this.currentPage;
    this.element.size = this.pageSize;
    this.getList();
  }

}
